import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "htmlFor", "required", "onClick", "color", "error", "fullWidth", "labelStyleOverride", "withFormControl"];
import { forwardRef } from 'react';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import styled from 'foundations-theming/utils';
import { Text } from '../../../components/Text';
import { StyledText } from '../../../components/Text/Text';
import { StyledRequiredIndicator } from '../FormControl/FormControl';
import { useIsDisplayOptimized } from '../../context/DisplayOptimizedContext';
import { useFieldsetContext } from '../../context/FieldsetContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const StyledLabel = styled.label.withConfig({
  displayName: "FormLabel__StyledLabel",
  componentId: "x090e9-0"
})(({
  $cssStyles,
  $required,
  $fullWidth,
  $labelStyleOverride,
  $withFormControl,
  theme
}) => {
  return Object.assign({
    display: 'inline-block',
    verticalAlign: 'middle',
    paddingBlockStart: theme.space['200'],
    paddingBlockEnd: theme.space['100'],
    paddingInlineEnd: theme.space['300'],
    '&[for]': {
      cursor: 'default'
    },
    [`& ${$withFormControl ? StyledRequiredIndicator : StyledText}`]: Object.assign({}, $required && {
      '&::after': {
        content: '"\x00a0*"'
      }
    })
  }, $fullWidth && {
    inlineSize: '100%',
    paddingInlineEnd: theme.space['0']
  }, $cssStyles, $labelStyleOverride);
});
export const FormLabel = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      children,
      htmlFor,
      required = false,
      onClick,
      color,
      fullWidth = false,
      labelStyleOverride: labelStyleOverrideProp = {},
      withFormControl = false
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    size
  } = useFieldsetContext();
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const labelStyleOverride = useMapTokenPropsToCSS(labelStyleOverrideProp);
  const isDisplayOptimized = useIsDisplayOptimized();
  return /*#__PURE__*/_jsx(StyledLabel, Object.assign({}, domProps, {
    $cssStyles: cssStyles,
    $required: required,
    htmlFor: htmlFor,
    onClick: onClick,
    ref: ref,
    $fullWidth: fullWidth,
    $labelStyleOverride: labelStyleOverride,
    $withFormControl: withFormControl,
    children: /*#__PURE__*/_jsx(Text, {
      as: "span",
      color: isDisplayOptimized ? 'text-core-subtle' : color,
      typography: isDisplayOptimized ? 'detail-100' : size === 'small' ? 'heading-25' : 'heading-50',
      children: children
    })
  }));
});
FormLabel.displayName = 'FormLabel';